import { useTheme } from "@mui/material";
import { CLOSE_SIDEBAR_WIDTH, DRAWER_WIDTH } from "common/theme";
import { UtilityContext } from "contexts";
import { useContext, useEffect, useState } from "react";
const pxToNumber = (px: string) => Number(px.replace('px', ''))
const useSidebar = (): [boolean, (open: boolean) => void, number] => {
  const { state: { sidebarOpen }, actions: { setSidebarOpen }} = useContext(UtilityContext);
  const [distanceFromLeft, setDistanceFromLeft] = useState<number>(0);
  const theme = useTheme();
  useEffect(() => {
    if(sidebarOpen) {
        setDistanceFromLeft(pxToNumber(theme.spacing(1)) + DRAWER_WIDTH);
    } else {
        setDistanceFromLeft(pxToNumber(theme.spacing(1)) + pxToNumber(CLOSE_SIDEBAR_WIDTH));
    }
  }, [sidebarOpen, theme]);
  return [sidebarOpen, setSidebarOpen, distanceFromLeft];
};

export default useSidebar;
